import { render, staticRenderFns } from "./FileListItem.vue?vue&type=template&id=96240c08&"
import script from "./FileListItem.vue?vue&type=script&lang=js&"
export * from "./FileListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports